var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable lines-around-comment */
import { withStyles } from "@mui/styles";
import React, { Component } from "react";
import { batch } from "react-redux";
// @ts-expect-error
import keyboardShortcut from "../../../../../modules/keyboardshortcut/keyboardshortcut";
// @ts-ignore
import { isSpeakerStatsDisabled } from "../../../../features/speaker-stats/functions";
import { ACTION_SHORTCUT_TRIGGERED, createShortcutEvent, createToolbarEvent, } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
import { getMultipleVideoSendingSupportFeatureFlag, getToolbarButtons, isToolbarButtonEnabled, } from "../../../base/config/functions.web";
import { openDialog, toggleDialog } from "../../../base/dialog/actions";
import { isIosMobileBrowser, isMobileBrowser, } from "../../../base/environment/utils";
import { translate } from "../../../base/i18n/functions";
import JitsiMeetJS from "../../../base/lib-jitsi-meet";
import { raiseHand } from "../../../base/participants/actions";
import { getLocalParticipant, hasRaisedHand, isLocalParticipantModerator, } from "../../../base/participants/functions";
import { connect } from "../../../base/redux/functions";
import { getLocalVideoTrack } from "../../../base/tracks/functions";
import ContextMenu from "../../../base/ui/components/web/ContextMenu";
import ContextMenuItemGroup from "../../../base/ui/components/web/ContextMenuItemGroup";
import { toggleChat } from "../../../chat/actions.web";
// @ts-ignore
import { ChatButton } from "../../../chat/components";
// @ts-ignore
import { EmbedMeetingButton } from "../../../embed-meeting";
// @ts-ignore
import { SharedDocumentButton } from "../../../etherpad";
import { FaceRecognitionButton, FaceMeshButton } from "../../../face-recognition/components";
import { PictureInPictureButton } from "../../../picture-in-picture/components";
// @ts-ignore
import { FeedbackButton } from "../../../feedback";
import { setGifMenuVisibility } from "../../../gifs/actions";
import { isGifEnabled } from "../../../gifs/functions";
// @ts-ignore
import { InviteButton } from "../../../invite/components/add-people-dialog";
import { isVpaasMeeting } from "../../../jaas/functions";
// @ts-ignore
import { KeyboardShortcutsButton } from "../../../keyboard-shortcuts";
import { 
// @ts-ignore
close as closeMaterialList, 
// @ts-ignore
open as openMaterialList,
// @ts-ignore
 } from "../../../material-list/actions";
// @ts-ignore
import { MaterialListButton } from "../../../material-list/components/web";
// @ts-ignore
import { getMaterialListOpen } from "../../../material-list/functions";
import { NoiseSuppressionButton } from "../../../noise-suppression/components";
import { close as closeParticipantsPane, open as openParticipantsPane,
// @ts-ignore
 } from "../../../participants-pane/actions";
// @ts-ignore
import { ParticipantsPaneButton } from "../../../participants-pane/components/web";
import { getParticipantsPaneOpen } from "../../../participants-pane/functions";
import { addReactionToBuffer } from "../../../reactions/actions.any";
import { toggleReactionsMenuVisibility } from "../../../reactions/actions.web";
import ReactionsMenuButton from "../../../reactions/components/web/ReactionsMenuButton";
import { REACTIONS } from "../../../reactions/constants";
import { isReactionsEnabled } from "../../../reactions/functions.any";
import { LiveStreamButton, RecordButton,
// @ts-ignore
 } from "../../../recording";
// @ts-ignore
import { isSalesforceEnabled } from "../../../salesforce/functions";
import { startScreenShareFlow } from "../../../screen-share/actions.web";
// @ts-ignore
import ShareAudioButton from "../../../screen-share/components/web/ShareAudioButton";
import { isScreenAudioSupported, isScreenVideoShared, } from "../../../screen-share/functions";
// @ts-ignore
import SecurityDialogButton from "../../../security/components/security-dialog/web/SecurityDialogButton";
// @ts-ignore
import { SettingsButton } from "../../../settings";
// @ts-ignore
import { SharedVideoButton } from "../../../shared-video/components";
// @ts-ignore
import { SpeakerStatsButton } from "../../../speaker-stats/components/web";
import SpeakerStats from "../../../speaker-stats/components/web/SpeakerStats";
import { ClosedCaptionButton,
// @ts-ignore
 } from "../../../subtitles";
import { TileViewButton, shouldDisplayTileView, toggleTileView,
// @ts-ignore
 } from "../../../video-layout";
// @ts-ignore
import { VideoQualityButton, VideoQualityDialog,
// @ts-ignore
 } from "../../../video-quality/components";
// @ts-ignore
import { VideoBackgroundButton } from "../../../virtual-background";
// @ts-ignore
import { FaceRegistrationButton } from "../../../face-registration/components/index";
import WhiteboardButton from "../../../whiteboard/components/web/WhiteboardButton";
import { isWhiteboardButtonVisible } from "../../../whiteboard/functions";
import { setFullScreen, setHangupMenuVisible, setOverflowMenuVisible, setToolbarHovered, showToolbox,
// @ts-ignore
 } from "../../actions";
import { toggleFaceMesh, toggleFaceRecognition, } from "../../../face-recognition/actions";
import { togglePictureInPicture } from "../../../picture-in-picture/actions";
import { NOTIFY_CLICK_MODE, NOT_APPLICABLE, THRESHOLDS } from "../../constants";
import { isDesktopShareButtonDisabled, isToolboxVisible, } from "../../functions";
import { getJwtDisabledButtons } from "../../functions.any";
// @ts-ignore
import DownloadButton from "../DownloadButton";
// @ts-ignore
import HangupButton from "../HangupButton";
// @ts-ignore
import HelpButton from "../HelpButton";
// @ts-ignore
import AudioSettingsButton from "./AudioSettingsButton";
// @ts-ignore
import DockIframeButton from "./DockIframeButton";
import { EndConferenceButton } from "./EndConferenceButton";
// @ts-ignore
import FullscreenButton from "./FullscreenButton";
import HangupMenuButton from "./HangupMenuButton";
import { LeaveConferenceButton } from "./LeaveConferenceButton";
// @ts-ignore
import LinkToSalesforceButton from "./LinkToSalesforceButton";
// @ts-ignore
import OverflowMenuButton from "./OverflowMenuButton";
// @ts-ignore
import ProfileButton from "./ProfileButton";
// @ts-ignore
import Separator from "./Separator";
// @ts-ignore
import ShareDesktopButton from "./ShareDesktopButton";
// @ts-ignore
import ToggleCameraButton from "./ToggleCameraButton";
// @ts-ignore
import UndockIframeButton from "./UndockIframeButton";
// @ts-ignore
import VideoSettingsButton from "./VideoSettingsButton";
const styles = (theme) => {
    return {
        toolboxContentItems: {
            // width: "unset",
            background: "rgba(0,0,0,0.6)",
            borderRadius: 0,
        },
        contextMenu: {
            position: "relative",
            right: "auto",
            maxHeight: "inherit",
            margin: 0,
            marginBottom: "8px",
            [theme.breakpoints.down(525)]: {
                right: '50px'
            },
            [theme.breakpoints.down(350)]: {
                right: '20px'
            },
            [theme.breakpoints.down(300)]: {
                left: '10px'
            },
        },
        hangupMenu: {
            position: "relative",
            right: "auto",
            display: "flex",
            flexDirection: "column",
            rowGap: "8px",
            margin: 0,
            padding: "16px",
            marginBottom: "8px",
        },
    };
};
/**
 * Implements the conference toolbox on React/Web.
 *
 * @augments Component
 */
class Toolbox extends Component {
    /**
     * Initializes a new {@code Toolbox} instance.
     *
     * @param {IProps} props - The read-only React {@code Component} props with
     * which the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this._onMouseOut = this._onMouseOut.bind(this);
        this._onMouseOver = this._onMouseOver.bind(this);
        this._onSetHangupVisible = this._onSetHangupVisible.bind(this);
        this._onSetOverflowVisible = this._onSetOverflowVisible.bind(this);
        this._onTabIn = this._onTabIn.bind(this);
        this._onShortcutToggleChat = this._onShortcutToggleChat.bind(this);
        this._onShortcutToggleFullScreen =
            this._onShortcutToggleFullScreen.bind(this);
        this._onShortcutToggleParticipantsPane =
            this._onShortcutToggleParticipantsPane.bind(this);
        this._onShortcutToggleMaterialList =
            this._onShortcutToggleMaterialList.bind(this);
        this._onShortcutToggleRaiseHand =
            this._onShortcutToggleRaiseHand.bind(this);
        this._onShortcutToggleScreenshare =
            this._onShortcutToggleScreenshare.bind(this);
        this._onShortcutToggleVideoQuality =
            this._onShortcutToggleVideoQuality.bind(this);
        this._onToolbarToggleParticipantsPane =
            this._onToolbarToggleParticipantsPane.bind(this);
        this._onToolbarToggleMaterialList =
            this._onToolbarToggleMaterialList.bind(this);
        this._onToolbarOpenVideoQuality =
            this._onToolbarOpenVideoQuality.bind(this);
        this._onToolbarToggleChat = this._onToolbarToggleChat.bind(this);
        this._onToolbarToggleFullScreen =
            this._onToolbarToggleFullScreen.bind(this);
        this._onToolbarToggleRaiseHand =
            this._onToolbarToggleRaiseHand.bind(this);
        this._onToolbarToggleScreenshare =
            this._onToolbarToggleScreenshare.bind(this);
        this._onShortcutToggleTileView =
            this._onShortcutToggleTileView.bind(this);
        this._onShortcutSpeakerStats = this._onShortcutSpeakerStats.bind(this);
        this._onEscKey = this._onEscKey.bind(this);
        this._onShortcutToggleFaceRecog =
            this._onShortcutToggleFaceRecog.bind(this);
        this._onShortcutToggleFaceMesh = this._onShortcutToggleFaceMesh.bind(this);
        this._onShortcutTogglePictureInPicture = this._onShortcutTogglePictureInPicture.bind(this);
    }
    /**
     * Sets keyboard shortcuts for to trigger ToolbarButtons actions.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        const { _toolbarButtons, t, dispatch, _reactionsEnabled, _gifsEnabled, _isSpeakerStatsDisabled, } = this.props;
        const KEYBOARD_SHORTCUTS = [
            isToolbarButtonEnabled("videoquality", _toolbarButtons) && {
                character: "Z",
                exec: this._onShortcutToggleVideoQuality,
                helpDescription: "toolbar.callQuality",
            },
            isToolbarButtonEnabled("chat", _toolbarButtons) && {
                character: "H",
                exec: this._onShortcutToggleChat,
                helpDescription: "keyboardShortcuts.toggleChat",
                altkey: true,
            },
            isToolbarButtonEnabled("desktop", _toolbarButtons) && {
                character: "D",
                exec: this._onShortcutToggleScreenshare,
                helpDescription: "keyboardShortcuts.toggleScreensharing",
            },
            isToolbarButtonEnabled("participants-pane", _toolbarButtons) && {
                character: "U",
                exec: this._onShortcutToggleParticipantsPane,
                helpDescription: "keyboardShortcuts.toggleParticipantsPane",
                altkey: true,
            },
            isToolbarButtonEnabled("material-list", _toolbarButtons) && {
                character: "J",
                exec: this._onShortcutToggleMaterialList,
                helpDescription: "keyboardShortcuts.toggleMaterialList",
            },
            isToolbarButtonEnabled("raisehand", _toolbarButtons) && {
                character: "Y",
                exec: this._onShortcutToggleRaiseHand,
                helpDescription: "keyboardShortcuts.raiseHand",
                altkey: true,
            },
            isToolbarButtonEnabled("fullscreen", _toolbarButtons) && {
                character: "S",
                exec: this._onShortcutToggleFullScreen,
                helpDescription: "keyboardShortcuts.fullScreen",
            },
            isToolbarButtonEnabled("tileview", _toolbarButtons) && {
                character: "W",
                exec: this._onShortcutToggleTileView,
                helpDescription: "toolbar.tileViewToggle",
            },
            !_isSpeakerStatsDisabled &&
                isToolbarButtonEnabled("stats", _toolbarButtons) && {
                character: "T",
                exec: this._onShortcutSpeakerStats,
                helpDescription: "keyboardShortcuts.showSpeakerStats",
            },
            isToolbarButtonEnabled("face-recognition", _toolbarButtons) && {
                character: "F",
                exec: this._onShortcutToggleFaceRecog,
                helpDescription: "keyboardShortcuts.faceRecognition",
                altkey: true,
            },
            isToolbarButtonEnabled("face-mesh", _toolbarButtons) && {
                character: "S",
                exec: this._onShortcutToggleFaceMesh,
                helpDescription: "keyboardShortcuts.faceMask",
                altkey: true,
            },
            isToolbarButtonEnabled("picture-in-picture", _toolbarButtons) && {
                character: "P",
                exec: this._onShortcutTogglePictureInPicture,
                helpDescription: "keyboardShortcuts.pictureInPicture",
                altkey: true,
            },
        ];
        KEYBOARD_SHORTCUTS.forEach((shortcut) => {
            if (typeof shortcut === "object") {
                APP.keyboardshortcut.registerShortcut(shortcut.character, null, shortcut.exec, shortcut.helpDescription, shortcut.altkey);
            }
        });
        if (!_reactionsEnabled) {
            // 리액션 disabled
            const REACTION_SHORTCUTS = Object.keys(REACTIONS).map((key) => {
                const onShortcutSendReaction = () => {
                    dispatch(addReactionToBuffer(key));
                    sendAnalytics(createShortcutEvent(`reaction.${key}`));
                };
                return {
                    character: REACTIONS[key].shortcutChar,
                    exec: onShortcutSendReaction,
                    helpDescription: t(`toolbar.reaction${key
                        .charAt(0)
                        .toUpperCase()}${key.slice(1)}`),
                    altKey: true,
                };
            });
            REACTION_SHORTCUTS.forEach((shortcut) => {
                APP.keyboardshortcut.registerShortcut(shortcut.character, null, shortcut.exec, shortcut.helpDescription, shortcut.altKey);
            });
            if (_gifsEnabled) {
                const onGifShortcut = () => {
                    batch(() => {
                        dispatch(toggleReactionsMenuVisibility());
                        dispatch(setGifMenuVisibility(true));
                    });
                };
                APP.keyboardshortcut.registerShortcut("G", null, onGifShortcut, t("keyboardShortcuts.giphyMenu"));
            }
        }
        $('div').removeClass('jitsi-icon jitsi-icon-default');
    }
    /**
     * Update the visibility of the {@code OverflowMenuButton}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
        const { _dialog, _visible, dispatch } = this.props;
        if (prevProps._overflowMenuVisible && !prevProps._dialog && _dialog) {
            this._onSetOverflowVisible(false);
            dispatch(setToolbarHovered(false));
        }
        if (prevProps._hangupMenuVisible && prevProps._visible && !_visible) {
            this._onSetHangupVisible(false);
            dispatch(setToolbarHovered(false));
        }
        // if (prevProps._overflowMenuVisible) {
        //     const tabs = document.querySelectorAll('[role="tab"]');
        //     const tabList = document.querySelector('[role="tablist"]');
        //
        //     console.log('Component Did Update');
        //     console.log(tabs);
        //     console.log(tabList);
        //
        //     function changeTabs(e) {
        //         const target = e.target;
        //         const parent = target.parentNode;
        //         const grandparent = parent.parentNode;
        //
        //         // Remove all current selected tabs
        //         parent
        //             .querySelectorAll('[aria-selected="true"]')
        //             .forEach((t) => t.setAttribute("aria-selected", false));
        //
        //         // Set this tab as selected
        //         target.setAttribute("aria-selected", true);
        //
        //         // Hide all tab panels
        //         grandparent
        //             .querySelectorAll('[role="tabpanel"]')
        //             .forEach((p) => p.setAttribute("hidden", true));
        //
        //         // Show the selected panel
        //         grandparent.parentNode
        //             .querySelector(`#${target.getAttribute("aria-controls")}`)
        //             .removeAttribute("hidden");
        //     }
        //
        //     // @ts-ignore
        //     tabs.forEach((tab) => {
        //         console.log(tab);
        //         // @ts-ignore
        //         //tab.addEventListener("click", changeTabs);
        //     });
        //
        //     let tabFocus = 0;
        //
        //     tabList.addEventListener("keyDown", (e) => {
        //         if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        //
        //             tabs[tabFocus].setAttribute("tabindex", -1);
        //             if (e.key === 'ArrowUP') {
        //                 console.log('arrowup');
        //                 tabFocus++;
        //                 // @ts-ignore
        //                 if (tabFocus >= tabs.length) {
        //                     tabFocus = 0;
        //                 }
        //             }
        //         } else if (e.key == 'ArrowDown') {
        //             console.log('arrowdown');
        //             tabFocus--;
        //             if (tabFocus < 0) {
        //                 // @ts-ignore
        //                 tabFocus = tabs.length - 1;
        //             }
        //         }
        //         tabs[tabFocus].setAttribute("tabindex", 0);
        //         // @ts-ignore
        //         tabs[tabFocus].focus();
        //     })
        //
        // }
    }
    /**
     * Removes keyboard shortcuts registered by this component.
     *x
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        ["A", "C", "D", "R", "S", "J"].forEach((letter) => APP.keyboardshortcut.unregisterShortcut(letter));
        if (this.props._reactionsEnabled) {
            Object.keys(REACTIONS)
                .map((key) => REACTIONS[key].shortcutChar)
                .forEach((letter) => APP.keyboardshortcut.unregisterShortcut(letter, true));
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        if (this.props._disabled) {
            return null;
        }
        const { _chatOpen, _visible, _toolbarButtons } = this.props;
        const rootClassNames = `new-toolbox ${_visible ? "visible" : ""} ${_toolbarButtons.length ? "" : "no-buttons"} ${_chatOpen ? "shift-right" : ""}`;
        return (React.createElement("div", { className: rootClassNames, id: "new-toolbox" }, this._renderToolboxContent()));
    }
    /**
     * Key handler for overflow/hangup menus.
     *
     * @param {KeyboardEvent} e - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscKey(e) {
        if ((e === null || e === void 0 ? void 0 : e.key) === "Escape") {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            this._closeHangupMenuIfOpen();
            this._closeOverflowMenuIfOpen();
        }
    }
    /**
     * Closes the hangup menu if opened.
     *
     * @private
     * @returns {void}
     */
    _closeHangupMenuIfOpen() {
        const { dispatch, _hangupMenuVisible } = this.props;
        _hangupMenuVisible && dispatch(setHangupMenuVisible(false));
    }
    /**
     * Closes the overflow menu if opened.
     *
     * @private
     * @returns {void}
     */
    _closeOverflowMenuIfOpen() {
        const { dispatch, _overflowMenuVisible } = this.props;
        _overflowMenuVisible && dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Dispatches an action to open the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _doOpenVideoQuality() {
        this.props.dispatch(openDialog(VideoQualityDialog));
    }
    /**
     * Dispatches an action to toggle the display of chat.
     *
     * @private
     * @returns {void}
     */
    _doToggleChat() {
        this.props.dispatch(toggleChat());
    }
    /**
     * Dispatches an action to toggle screensharing.
     *
     * @private
     * @returns {void}
     */
    _doToggleFullScreen() {
        const fullScreen = !this.props._fullScreen;
        this.props.dispatch(setFullScreen(fullScreen));
    }
    /**
     * Dispatches an action to toggle face recognition.
     *
     * @private
     * @returns {void}
     */
    _doToggleFaceRecog() {
        const faceRecog = !this.props._faceRecognition;
        // @ts-ignore
        this.props.dispatch(toggleFaceRecognition(faceRecog));
    }
    /**
     * Dispatches an action to toggle face mesh visualization.
     *
     * @private
     * @returns {void}
     */
    _doToggleFaceMesh() {
        const faceMesh = !this.props._faceMesh;
        // @ts-ignore
        this.props.dispatch(toggleFaceMesh(faceMesh));
    }
    _doTogglePictureInPicture() {
        const pictureInPicture = !this.props._pictureInPicture;
        // @ts-ignore
        this.props.dispatch(togglePictureInPicture(pictureInPicture));
    }
    /**
     * Dispatches an action to toggle the local participant's raised hand state.
     *
     * @private
     * @returns {void}
     */
    _doToggleRaiseHand() {
        const { _raisedHand } = this.props;
        this.props.dispatch(raiseHand(!_raisedHand));
    }
    /**
     * Dispatches an action to toggle screensharing.
     *
     * @private
     * @param {boolean} enabled - The state to toggle screen sharing to.
     * @param {boolean} audioOnly - Only share system audio.
     * @returns {void}
     */
    _doToggleScreenshare() {
        const { _desktopSharingButtonDisabled, _desktopSharingEnabled, _screenSharing, dispatch, } = this.props;
        if (_desktopSharingEnabled && !_desktopSharingButtonDisabled) {
            dispatch(startScreenShareFlow(!_screenSharing));
        }
    }
    /**
     * Dispatches an action to toggle the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _doToggleVideoQuality() {
        this.props.dispatch(toggleDialog(VideoQualityDialog));
    }
    /**
     * Dispaches an action to toggle tile view.
     *
     * @private
     * @returns {void}
     */
    _doToggleTileView() {
        this.props.dispatch(toggleTileView());
    }
    /**
     * Returns all buttons that could be rendered.
     *
     * @param {Object} state - The redux state.
     * @returns {Object} The button maps mainMenuButtons and overflowMenuButtons.
     */
    _getAllButtons() {
        const { _feedbackConfigured, _hasSalesforce, _isIosMobile, _isMobile, _isSpeakerStatsDisabled, _multiStreamModeEnabled, _screenSharing, _whiteboardEnabled, _isModerator } = this.props;
        const microphone = {
            key: "microphone",
            Content: AudioSettingsButton,
            group: 0,
        };
        const camera = {
            key: "camera",
            Content: VideoSettingsButton,
            group: 0,
        };
        const profile = this._isProfileVisible() && {
            key: "profile",
            Content: ProfileButton,
            group: 1,
        };
        const chat = {
            key: "chat",
            Content: ChatButton,
            handleClick: this._onToolbarToggleChat,
            group: 2,
        };
        const desktop = this._showDesktopSharingButton() && {
            key: "desktop",
            Content: ShareDesktopButton,
            handleClick: this._onToolbarToggleScreenshare,
            group: 2,
        };
        const raisehand = {
            key: "raisehand",
            Content: ReactionsMenuButton,
            handleClick: this._onToolbarToggleRaiseHand,
            group: 2,
        };
        const participants = {
            key: "participants-pane",
            Content: ParticipantsPaneButton,
            handleClick: this._onToolbarToggleParticipantsPane,
            group: 2,
        };
        const materials = {
            key: "material-list",
            Content: MaterialListButton,
            handleClick: this._onToolbarToggleMaterialList,
            group: 2,
        };
        const invite = {
            key: "invite",
            Content: InviteButton,
            group: 2,
        };
        const tileview = {
            key: "tileview",
            Content: TileViewButton,
            group: 2,
        };
        const toggleCamera = {
            key: "toggle-camera",
            Content: ToggleCameraButton,
            group: 2,
        };
        const videoQuality = {
            key: "videoquality",
            Content: VideoQualityButton,
            handleClick: this._onToolbarOpenVideoQuality,
            group: 2,
        };
        const fullscreen = !_isIosMobile && {
            key: "fullscreen",
            Content: FullscreenButton,
            handleClick: this._onToolbarToggleFullScreen,
            group: 2,
        };
        const security = {
            key: "security",
            alias: "info",
            Content: SecurityDialogButton,
            group: 2,
        };
        const cc = {
            key: "closedcaptions",
            Content: ClosedCaptionButton,
            group: 2,
        };
        const recording = {
            key: "recording",
            Content: RecordButton,
            group: 2,
        };
        const livestreaming = {
            key: "livestreaming",
            Content: LiveStreamButton,
            group: 2,
        };
        const linkToSalesforce = _hasSalesforce && {
            key: "linktosalesforce",
            Content: LinkToSalesforceButton,
            group: 2,
        };
        const shareVideo = {
            key: "sharedvideo",
            Content: SharedVideoButton,
            group: 3,
        };
        const shareAudio = this._showAudioSharingButton() && {
            key: "shareaudio",
            Content: ShareAudioButton,
            group: 3,
        };
        const noiseSuppression = {
            key: "noisesuppression",
            Content: NoiseSuppressionButton,
            group: 3,
        };
        const whiteboard = _whiteboardEnabled && {
            key: "whiteboard",
            Content: WhiteboardButton,
            group: 3,
        };
        const faceRecognition = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "face-recognition",
            Content: FaceRecognitionButton,
            group: 3,
        };
        const faceMesh = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "face-mesh",
            Content: FaceMeshButton,
            group: 3,
        };
        const pictureInPicture = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "picture-in-picture",
            Content: PictureInPictureButton,
            group: 3,
        };
        const etherpad = {
            key: "etherpad",
            Content: SharedDocumentButton,
            group: 3,
        };
        const virtualBackground = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "select-background",
            Content: VideoBackgroundButton,
            group: 3,
        };
        const faceRegistration = (_multiStreamModeEnabled ||
            !_screenSharing) && {
            key: "face-registration",
            Content: FaceRegistrationButton,
            group: 3,
        };
        const dockIframe = {
            key: "dock-iframe",
            Content: DockIframeButton,
            group: 3,
        };
        const undockIframe = {
            key: "undock-iframe",
            Content: UndockIframeButton,
            group: 3,
        };
        const speakerStats = !_isSpeakerStatsDisabled && {
            key: "stats",
            Content: SpeakerStatsButton,
            group: 3,
        };
        const settings = {
            key: "settings",
            Content: SettingsButton,
            group: 4,
        };
        const shortcuts = !_isMobile &&
            keyboardShortcut.getEnabled() && {
            key: "shortcuts",
            Content: KeyboardShortcutsButton,
            group: 4,
        };
        const embed = this._isEmbedMeetingVisible() && {
            key: "embedmeeting",
            Content: EmbedMeetingButton,
            group: 4,
        };
        const feedback = _feedbackConfigured && {
            key: "feedback",
            Content: FeedbackButton,
            group: 4,
        };
        const download = {
            key: "download",
            Content: DownloadButton,
            group: 4,
        };
        const help = {
            key: "help",
            Content: HelpButton,
            group: 4,
        };
        return {
            microphone,
            camera,
            profile,
            desktop,
            chat,
            raisehand,
            participants,
            materials,
            invite,
            tileview,
            toggleCamera,
            videoQuality,
            fullscreen,
            security,
            cc,
            recording,
            livestreaming,
            linkToSalesforce,
            // shareVideo, 유튜브 비디오 공유 더보기 메뉴에서 삭제
            // shareAudio, 소리 공유 더보기 메뉴에서 삭제
            noiseSuppression,
            faceRecognition,
            faceMesh,
            pictureInPicture,
            // faceRegistration,
            whiteboard,
            etherpad,
            virtualBackground,
            dockIframe,
            undockIframe,
            speakerStats,
            settings,
            shortcuts,
            // embed, embed 태그 안내 더보기 메뉴에서 삭제
            feedback,
            download,
            help,
        };
    }
    /**
     * Returns the notify mode of the given toolbox button.
     *
     * @param {string} btnName - The toolbar button's name.
     * @returns {string|undefined} - The button's notify mode.
     */
    _getButtonNotifyMode(btnName) {
        var _a;
        const notify = (_a = this.props._buttonsWithNotifyClick) === null || _a === void 0 ? void 0 : _a.find((btn) => (typeof btn === "string" && btn === btnName) ||
            (typeof btn === "object" && btn.key === btnName));
        if (notify) {
            return typeof notify === "string" || notify.preventExecution
                ? NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY
                : NOTIFY_CLICK_MODE.ONLY_NOTIFY;
        }
    }
    /**
     * Sets the notify click mode for the buttons.
     *
     * @param {Object} buttons - The list of toolbar buttons.
     * @returns {void}
     */
    _setButtonsNotifyClickMode(buttons) {
        var _a;
        if (typeof APP === "undefined" ||
            !((_a = this.props._buttonsWithNotifyClick) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        Object.values(buttons).forEach((button) => {
            if (typeof button === "object") {
                button.notifyMode = this._getButtonNotifyMode(button.key);
            }
        });
    }
    /**
     * Returns all buttons that need to be rendered.
     *
     * @param {Object} state - The redux state.
     * @returns {Object} The visible buttons arrays .
     */
    _getVisibleButtons() {
        const { _clientWidth, _toolbarButtons, _jwtDisabledButons } = this.props;
        const buttons = this._getAllButtons();
        this._setButtonsNotifyClickMode(buttons);
        const isHangupVisible = isToolbarButtonEnabled("hangup", _toolbarButtons);
        const { order } = THRESHOLDS.find(({ width }) => _clientWidth > width) ||
            THRESHOLDS[THRESHOLDS.length - 1];
        let sliceIndex = order.length + 2;
        const keys = Object.keys(buttons);
        const filtered = [
            ...order.map((key) => buttons[key]),
            ...Object.values(buttons).filter((button, index) => !order.includes(keys[index])),
        ]
            .filter(Boolean)
            .filter(({ key, alias = NOT_APPLICABLE }) => !_jwtDisabledButons.includes(key) &&
            (isToolbarButtonEnabled(key, _toolbarButtons) ||
                isToolbarButtonEnabled(alias, _toolbarButtons)));
        if (isHangupVisible) {
            sliceIndex -= 1;
        }
        // This implies that the overflow button will be displayed, so save some space for it.
        if (sliceIndex < filtered.length) {
            sliceIndex -= 1;
        }
        return {
            mainMenuButtons: filtered.slice(0, sliceIndex),
            overflowMenuButtons: filtered.slice(sliceIndex),
        };
    }
    /**
     * Dispatches an action signaling the toolbar is not being hovered.
     *
     * @private
     * @returns {void}
     */
    _onMouseOut() {
        const { _overflowMenuVisible, dispatch } = this.props;
        !_overflowMenuVisible && dispatch(setToolbarHovered(false));
    }
    /**
     * Dispatches an action signaling the toolbar is being hovered.
     *
     * @private
     * @returns {void}
     */
    _onMouseOver() {
        this.props.dispatch(setToolbarHovered(true));
    }
    /**
     * Sets the visibility of the hangup menu.
     *
     * @param {boolean} visible - Whether or not the hangup menu should be
     * displayed.
     * @private
     * @returns {void}
     */
    _onSetHangupVisible(visible) {
        this.props.dispatch(setHangupMenuVisible(visible));
        this.props.dispatch(setToolbarHovered(visible));
    }
    /**
     * Sets the visibility of the overflow menu.
     *
     * @param {boolean} visible - Whether or not the overflow menu should be
     * displayed.
     * @private
     * @returns {void}
     */
    _onSetOverflowVisible(visible) {
        this.props.dispatch(setOverflowMenuVisible(visible));
        this.props.dispatch(setToolbarHovered(visible));
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of chat.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleChat() {
        var _a;
        sendAnalytics(createShortcutEvent("toggle.chat", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._chatOpen,
        }));
        // Checks if there was any text selected by the user.
        // Used for when we press simultaneously keys for copying
        // text messages from the chat board
        if (((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString()) !== "") {
            return false;
        }
        this._doToggleChat();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of the participants pane.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleParticipantsPane() {
        sendAnalytics(createShortcutEvent("toggle.participants-pane", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._participantsPaneOpen,
        }));
        this._onToolbarToggleParticipantsPane();
    }
    _onShortcutToggleMaterialList() {
        sendAnalytics(
        // @ts-ignore
        createShortcutEvent("toggle.material-list", {
            // @ts-ignore
            enable: !this.props._materialListOpen,
        }));
        this._onToolbarToggleMaterialList();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling the display of Video Quality.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleVideoQuality() {
        sendAnalytics(createShortcutEvent("video.quality"));
        this._doToggleVideoQuality();
    }
    /**
     * Dispatches an action for toggling the tile view.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleTileView() {
        sendAnalytics(createShortcutEvent("toggle.tileview", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._tileViewEnabled,
        }));
        this._doToggleTileView();
    }
    _onShortcutToggleFaceRecog() {
        sendAnalytics(
        // @ts-ignore
        createShortcutEvent("toggle.faceRecog", {
            // @ts-ignore
            enable: !this.props._faceRecognition,
        }));
        this._doToggleFaceRecog();
    }
    _onShortcutToggleFaceMesh() {
        sendAnalytics(
        // @ts-ignore
        createShortcutEvent("toggle.faceMesh", {
            // @ts-ignore
            maskEnable: !this.props._faceMesh,
        }));
        this._doToggleFaceMesh();
    }
    _onShortcutTogglePictureInPicture() {
        sendAnalytics(
        // @ts-ignore
        createShortcutEvent("toggle.pictureInPicture", {
            // @ts-ignore
            pip: !this.props._pictureInPicture,
        }));
        this._doTogglePictureInPicture();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling full screen mode.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleFullScreen() {
        sendAnalytics(createShortcutEvent("toggle.fullscreen", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._fullScreen,
        }));
        this._doToggleFullScreen();
    }
    /**
    * Creates an analytics keyboard shortcut event and dispatches an action for
    * toggling Previous page.
    *
    * @private
    * @returns {void}
    */
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling raise hand.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleRaiseHand() {
        sendAnalytics(createShortcutEvent("toggle.raise.hand", ACTION_SHORTCUT_TRIGGERED, { enable: !this.props._raisedHand }));
        this._doToggleRaiseHand();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling screensharing.
     *
     * @private
     * @returns {void}
     */
    _onShortcutToggleScreenshare() {
        // Ignore the shortcut if the button is disabled.
        if (this.props._desktopSharingButtonDisabled) {
            return;
        }
        sendAnalytics(createShortcutEvent("toggle.screen.sharing", ACTION_SHORTCUT_TRIGGERED, {
            enable: !this.props._screenSharing,
        }));
        this._doToggleScreenshare();
    }
    /**
     * Creates an analytics keyboard shortcut event and dispatches an action for
     * toggling speaker stats.
     *
     * @private
     * @returns {void}
     */
    _onShortcutSpeakerStats() {
        sendAnalytics(createShortcutEvent("speaker.stats"));
        this._doToggleSpekearStats();
    }
    /**
     * Dispatches an action to toggle speakerStats.
     *
     * @private
     * @returns {void}
     */
    _doToggleSpekearStats() {
        const { dispatch } = this.props;
        dispatch(toggleDialog(SpeakerStats, {
            conference: APP.conference,
        }));
    }
    /**
     * Toggle the toolbar visibility when tabbing into it.
     *
     * @returns {void}
     */
    _onTabIn() {
        if (!this.props._visible) {
            this.props.dispatch(showToolbox());
        }
    }
    /**
     * Dispatches an action for toggling the participants pane.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleParticipantsPane() {
        const { dispatch, _participantsPaneOpen } = this.props;
        if (_participantsPaneOpen) {
            dispatch(closeParticipantsPane());
        }
        else {
            dispatch(openParticipantsPane());
        }
    }
    _onToolbarToggleMaterialList() {
        const { dispatch, _materialListOpen } = this.props;
        if (_materialListOpen) {
            dispatch(closeMaterialList());
        }
        else {
            dispatch(openMaterialList());
        }
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * open the video quality dialog.
     *
     * @private
     * @returns {void}
     */
    _onToolbarOpenVideoQuality() {
        sendAnalytics(createToolbarEvent("video.quality"));
        this._doOpenVideoQuality();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * the display of chat.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleChat() {
        sendAnalytics(createToolbarEvent("toggle.chat", {
            enable: !this.props._chatOpen,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleChat();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * full screen mode.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleFullScreen() {
        sendAnalytics(createToolbarEvent("toggle.fullscreen", {
            enable: !this.props._fullScreen,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleFullScreen();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * raise hand.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleRaiseHand() {
        sendAnalytics(createToolbarEvent("raise.hand", {
            enable: !this.props._raisedHand,
        }));
        this._doToggleRaiseHand();
    }
    /**
     * Creates an analytics toolbar event and dispatches an action for toggling
     * screensharing.
     *
     * @private
     * @returns {void}
     */
    _onToolbarToggleScreenshare() {
        sendAnalytics(createToolbarEvent("toggle.screen.sharing", {
            enable: !this.props._screenSharing,
        }));
        this._closeOverflowMenuIfOpen();
        this._doToggleScreenshare();
    }
    /**
     * Returns true if the audio sharing button should be visible and
     * false otherwise.
     *
     * @returns {boolean}
     */
    _showAudioSharingButton() {
        const { _desktopSharingEnabled } = this.props;
        return _desktopSharingEnabled && isScreenAudioSupported();
    }
    /**
     * Returns true if the desktop sharing button should be visible and
     * false otherwise.
     *
     * @returns {boolean}
     */
    _showDesktopSharingButton() {
        return this.props._desktopSharingEnabled;
    }
    /**
     * Returns true if the embed meeting button is visible and false otherwise.
     *
     * @returns {boolean}
     */
    _isEmbedMeetingVisible() {
        return !this.props._isVpaasMeeting && !this.props._isMobile;
    }
    /**
     * Returns true if the profile button is visible and false otherwise.
     *
     * @returns {boolean}
     */
    _isProfileVisible() {
        return !this.props._isProfileDisabled;
    }
    /**
     * Renders the toolbox content.
     *
     * @returns {ReactElement}
     */
    _renderToolboxContent() {
        const { _endConferenceSupported, _hangupMenuVisible, _isMobile, _overflowDrawer, _overflowMenuVisible, _reactionsEnabled, _toolbarButtons, classes, t, } = this.props;
        const toolbarAccLabel = "toolbar.accessibilityLabel.moreActionsMenu";
        const containerClassName = `toolbox-content${_isMobile ? " toolbox-content-mobile" : ""}`;
        const { mainMenuButtons, overflowMenuButtons } = this._getVisibleButtons();
        return (React.createElement("div", { className: containerClassName },
            React.createElement("div", Object.assign({ className: "toolbox-content-wrapper", onFocus: this._onTabIn }, (_isMobile
                ? {}
                : {
                    onMouseOut: this._onMouseOut,
                    onMouseOver: this._onMouseOver,
                })),
                React.createElement("div", { className: classes.toolboxContentItems },
                    mainMenuButtons.map((_a) => {
                        var { Content, key } = _a, rest = __rest(_a, ["Content", "key"]);
                        return Content !== Separator && (React.createElement(Content, Object.assign({}, rest, { buttonKey: key, key: key })));
                    }),
                    Boolean(overflowMenuButtons.length) && (React.createElement(OverflowMenuButton, { ariaControls: "overflow-menu", isOpen: _overflowMenuVisible, key: "overflow-menu", onVisibilityChange: this._onSetOverflowVisible, showMobileReactions: _reactionsEnabled &&
                            overflowMenuButtons.find(({ key }) => key === "raisehand") },
                        React.createElement(ContextMenu, { accessibilityLabel: t(toolbarAccLabel), className: classes.contextMenu, hidden: false, inDrawer: _overflowDrawer, onKeyDown: this._onEscKey }, overflowMenuButtons
                            .reduce((acc, val) => {
                            if (acc.length) {
                                const prev = acc[acc.length - 1];
                                const group = prev[prev.length - 1].group;
                                if (group === val.group) {
                                    prev.push(val);
                                }
                                else {
                                    acc.push([val]);
                                }
                            }
                            else {
                                acc.push([val]);
                            }
                            return acc;
                        }, [])
                            .map((buttonGroup) => (React.createElement(ContextMenuItemGroup, { key: `group-${buttonGroup[0].group}` }, buttonGroup.map((_a) => {
                            var { key, Content } = _a, rest = __rest(_a, ["key", "Content"]);
                            return (key !== "raisehand" ||
                                !_reactionsEnabled) && (React.createElement(Content, Object.assign({}, rest, { buttonKey: key, contextMenu: true, key: key, showLabel: true })));
                        }))))))),
                    isToolbarButtonEnabled("hangup", _toolbarButtons) &&
                        (_endConferenceSupported ? (React.createElement(HangupMenuButton, { ariaControls: "hangup-menu", isOpen: _hangupMenuVisible, key: "hangup-menu", notifyMode: this._getButtonNotifyMode("hangup-menu"), onVisibilityChange: this._onSetHangupVisible },
                            React.createElement(ContextMenu, { accessibilityLabel: t(toolbarAccLabel), className: classes.hangupMenu, hidden: false, inDrawer: _overflowDrawer, onKeyDown: this._onEscKey },
                                React.createElement(EndConferenceButton, { buttonKey: "end-meeting", notifyMode: this._getButtonNotifyMode("end-meeting") }),
                                React.createElement(LeaveConferenceButton, { buttonKey: "hangup", notifyMode: this._getButtonNotifyMode("hangup") })))) : (React.createElement(HangupButton, { buttonKey: "hangup", customClass: "hangup-button", key: "hangup-button", notifyMode: this._getButtonNotifyMode("hangup"), visible: isToolbarButtonEnabled("hangup", _toolbarButtons) })))))));
    }
}
/**
 * Maps (parts of) the redux state to {@link Toolbox}'s React {@code Component}
 * props.
 *
 * @param {Object} state - The redux store/state.
 * @param {Object} ownProps - The props explicitly passed.
 * @private
 * @returns {{}}
 */
function _mapStateToProps(state, ownProps) {
    const { conference } = state["features/base/conference"];
    const endConferenceSupported = conference === null || conference === void 0 ? void 0 : conference.isEndConferenceSupported();
    const { buttonsWithNotifyClick, callStatsID, disableProfile, iAmRecorder, iAmSipGateway, } = state["features/base/config"];
    const { fullScreen, hangupMenuVisible, overflowMenuVisible, overflowDrawer, } = state["features/toolbox"];
    const localParticipant = getLocalParticipant(state);
    const localVideo = getLocalVideoTrack(state["features/base/tracks"]);
    const { clientWidth } = state["features/base/responsive-ui"];
    const { enabled, maskEnabled } = state["features/face-recognition"];
    const { pip } = state["features/picture-in-picture"];
    const toolbarButtons = ownProps.toolbarButtons || getToolbarButtons(state);
    return {
        _backgroundType: state["features/virtual-background"].backgroundType,
        _buttonsWithNotifyClick: buttonsWithNotifyClick,
        _chatOpen: state["features/chat"].isOpen,
        _clientWidth: clientWidth,
        _conference: conference,
        _desktopSharingEnabled: JitsiMeetJS.isDesktopSharingEnabled(),
        _desktopSharingButtonDisabled: isDesktopShareButtonDisabled(state),
        _dialog: Boolean(state["features/base/dialog"].component),
        _disabled: Boolean(iAmRecorder || iAmSipGateway),
        _endConferenceSupported: Boolean(endConferenceSupported),
        _feedbackConfigured: Boolean(callStatsID),
        _fullScreen: fullScreen,
        _faceRecog: enabled,
        _pictureInPicture: pip,
        _faceMesh: maskEnabled,
        _gifsEnabled: isGifEnabled(state),
        _isProfileDisabled: Boolean(disableProfile),
        _isIosMobile: isIosMobileBrowser(),
        _isMobile: isMobileBrowser(),
        _isSpeakerStatsDisabled: isSpeakerStatsDisabled(state),
        _isVpaasMeeting: isVpaasMeeting(state),
        _jwtDisabledButons: getJwtDisabledButtons(state),
        _hasSalesforce: isSalesforceEnabled(state),
        _hangupMenuVisible: hangupMenuVisible,
        _localParticipantID: localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.id,
        _localVideo: localVideo,
        _multiStreamModeEnabled: getMultipleVideoSendingSupportFeatureFlag(state),
        _overflowMenuVisible: overflowMenuVisible,
        _overflowDrawer: overflowDrawer,
        _participantsPaneOpen: getParticipantsPaneOpen(state),
        _materialListOpen: getMaterialListOpen(state),
        _raisedHand: hasRaisedHand(localParticipant),
        _reactionsEnabled: isReactionsEnabled(state),
        _screenSharing: isScreenVideoShared(state),
        _tileViewEnabled: shouldDisplayTileView(state),
        _toolbarButtons: toolbarButtons,
        _virtualSource: state["features/virtual-background"].virtualSource,
        _visible: isToolboxVisible(state),
        _whiteboardEnabled: isWhiteboardButtonVisible(state),
        _isModerator: isLocalParticipantModerator(state)
    };
}
export default translate(connect(_mapStateToProps)(withStyles(styles)(Toolbox)));
